import FilterDetailedModal from './FilterDetailedModal';

export default FilterDetailedModal;
